import { useContext, useEffect, useState } from 'react';
import { Context } from '../..';
import { observer } from 'mobx-react-lite';
import { fetchApplications } from '../../http/applicationsAPI';
import search_icon from '../../static/admin_icons/magnifier.svg'
import DeleteApplicationModal from '../Modals/DeleteApplicationModal';

const Applications = observer(({onShow, onHide}) => {
    const { application } = useContext(Context);
    const [applications, setApplications] = useState([]);
    const [searchText,setSearchText] = useState('')
    const [visible,setVisible] = useState(false)
    const [ID, setID] = useState(null)
    useEffect(() => {
        fetchApplications().then(data => {
            setApplications(data.applications);
        });
    }, []);
    if (!application) {
        return (<div> Загрузка..</div>);
    }
    const filteredApplication = applications.filter(_application =>{
        return _application.name.toLowerCase()
        .includes(searchText.toLocaleLowerCase()) 
        ||
         _application.email.toLowerCase().includes(searchText.toLocaleLowerCase())
    })
    return (
        <div className='centered' style={{flexDirection:'column',width:'100%',height:'100%'}}>
            <div className='search-box'>
                <search>
                    <form method="get">
                        <input 
                        type='search'
                        name='search-text'
                        placeholder='Введите имя или email'
                        onChange={(e) => setSearchText(e.target.value)}
                        />
                        <label for='search-text'>
                            <img 
                                src={search_icon} 
                                alt='search'
                                className='search__img'/>
                        </label>
                    </form>
            </search> 
            </div>
            <div className='application-container'>
                
            {applications.length > 0 ? (
                filteredApplication.map((item) => (
                    <div key={item.id} className='application-card'>
                        <ul>
                            <li><strong>{'Имя:'}</strong> {item.name}</li>
                            <li><strong>{'Телефон: '}</strong> {item.phone_number}</li>
                            <li><strong>{'Email: '}</strong>  {item.email}</li>
                            <li><strong>{'Сообщение: '}</strong> {item.text}</li>
                            <li><button className='red-btn' onClick={() => {
                                setID(item.id)
                                setVisible(true)
                            }}>X</button></li>
                        </ul>
                    </div>
                ))
            ) : (
                <div>Loading...</div>
            )}
            <DeleteApplicationModal
             onHide={() =>setVisible(false)}
             show={visible}
             id ={ID}
             name={`Вы точно хотите удалить данную заявку ID: ${ID} ?`}
             />
        </div></div>
    );
});

export default Applications;